import { Icon, Typography } from 'src/modules/core/components'
import { IconName } from 'src/modules/core/components/icon/icon.interface'
import { CALENDAR_OPTIONS } from './add-to-calendar.domain'
import type { AddToCalendarProps } from './add-to-calendar.interface'
import classes from './add-to-calendar.module.scss'
import { useAddToCalendar } from './use-add-to-calendar'

export function AddToCalendar(props: AddToCalendarProps) {
  const f = useAddToCalendar(props)

  return (
    <div className={classes.section}>
      <div className={classes.header}>
        <Typography variant="body" className={classes.sectionTitle}>
          Add to Your Calendar
        </Typography>
      </div>
      <div className={classes.options}>
        {CALENDAR_OPTIONS.map((option) => (
          <button
            key={option.name}
            type="button"
            className={classes.option}
            onClick={() => f.handleCalendarClick(option.type)}
            disabled={!f.calendarEventData}
          >
            <Icon name={option.icon as IconName} className={classes.optionIcon} />
            <Typography variant="body">{option.name}</Typography>
          </button>
        ))}
      </div>
      <Typography variant="body" className={classes.instruction}>
        Choose your preferred calendar app or download the .ics file to add this appointment to any calendar
        application.
      </Typography>
    </div>
  )
}
